import { createContext } from "react";

export default createContext<{
  platform: "android" | "ios";
  chromeHeight: number;
}>({
  platform: "ios",
  chromeHeight: 40,
});
